export default __webpack_public_path__ + "static/media/image.virtual-office-solutions.54c1b45a.png";